export const InputType = {
    ProjectName: 1,
    ProjectEmails: 2,
    ProjectDescription: 3,
    ClassName: 4,
    FeatureName: 5

};
